export function ds24_retrieve( object: any, key: string, default_value?: any )
{
    if (typeof object[key] == 'undefined')
        return default_value;

    return object[key];
}